<div class="last-saved-header">
   <p-dropdown
      *ngIf="selectedPractice()"
      class="contest-select"
      [options]="contestOptions"
      optionLabel="label"
      optionValue="value"
      [(ngModel)]="selectedContestNumber"
      (onChange)="onContestChange($event.value)"></p-dropdown>

   <span class="last-saved-text">
      <span class="lst-label">
         <i class="fa fa-clock"></i>
         &nbsp;Data last updated on
      </span>
      <span class="lpd-label">
         {{ selectedPractice()?.lastProcessDate | date : "MMMM d, y h:mm a" }}
      </span>
   </span>
</div>

<vc-practice-select
   [autoselect]="true"
   (onSelected)="onPracticeSKeySelected($event)"></vc-practice-select>

<div class="leaderboard-container">
   <a
      href="javascript:void(0);"
      (click)="zohoModal.openModal()">
      <div class="fixedHelp">
         <h6>
            Problem with your report?
            <br />
            <span class="helpLink">Click here to issue a helpdesk ticket</span>
         </h6>
      </div>
   </a>
   <img
      src="assets/leaderboard/waveTopLeft.png"
      class="wave wave-left" />

   <div class="pageTopRight">
      <img
         [src]="selectedPractice()?.logoUrl"
         class="top-left-logo" />
      {{ selectedPractice()?.name }}
   </div>

   <img
      src="assets/leaderboard/waveTopRight.png"
      class="wave wave-right" />

   <div class="leaderboard-header">
      <img
         src="assets/leaderboard/summerSplash.png"
         alt="Summer Splash Contest"
         class="leaderboard-header-logo" />
   </div>

   <section class="intro">
      <div
         *ngIf="loading(); else leaderContent"
         class="catLoader">
         <img src="/assets/catSpinner.gif" />
         <br />
         <br />
         Loading...
      </div>

      <ng-template #leaderContent>
         <div class="intro-box">
            <div
               class="splash-heading"
               style="display: flex; align-items: center; gap: 1rem">
               <h2 style="margin: 0">The Big Splash Back</h2>
               <img
                  *ngIf="selectedPractice().stats.isWinner"
                  src="assets/leaderboard/contestOneWinner.png"
                  alt="Splash Logo"
                  style="height: 80px" />
            </div>
            <h6>Let’s make a splash and help more pets!</h6>
            <p>
               Whether they are new or lapsed, let's make sure our pets are protected. This metric highlights your hospital's impact on greeting new
               or reengaging existing pet owners to support consistent, long-term pet health.
            </p>
            <a
               target="_blank"
               href="https://vetcor.skyworld.com/userfilesV3/files/document-library/PMO/Summer%20Splash%20Contest%20-%20Big%20Splash%20Back%20(2).pdf">
               Big Splash Back Contest Detailer &raquo;
            </a>
            <div class="resources-box">
               <h4>Tools & Resources to Be Successful</h4>
               <ul>
                  <li>
                     <a
                        target="_blank"
                        href="https://vetcor.skyworld.com/userfilesV3/files/document-library/PMO/Big%20Splash%20Back%20-%20Team%20Flyer.pdf">
                        Big Splash Back - Team Flyer
                     </a>
                  </li>
                  <li>
                     <a
                        target="_blank"
                        href="https://vetcor.skyworld.com/userfilesV3/files/document-library/PMO/Big%20Splash%20Back%20Progress%20Tracker.pdf">
                        Big Splash Back Progress Tracker
                     </a>
                  </li>
                  <li>
                     <a
                        target="_blank"
                        href="https://vetcor.skyworld.com/userfilesV3/files/document-library/PMO/Reactivating%20Past%20Due%20Pets%20Best%20Practices.pdf">
                        Reactivating Past Due Pets Best Practices
                     </a>
                  </li>
               </ul>
            </div>
         </div>

         <div
            *ngIf="showBloodTests() && !showLinks()"
            class="intro-box">
            <h2>Sun, Fun, and BW Done!</h2>
            <h6>Wellness that shines from the inside out! How many pets can you help to establish routine annual bloodwork habits?</h6>
            <p>Each contest period, you can earn up to $500 for your hospital by achieving the goal number of proactive health screens.</p>
            <a
               target="_blank"
               href="https://vetcor.skyworld.com/userfilesV3/files/document-library/PMO/Sun%20Fun%20and%20BW%20Done%20Contest%20Detailer.pdf">
               Sun, Fun and BW Done Contest Detailer &raquo;
            </a>
            <div class="resources-box">
               <h4>Tools & Resources to Be Successful</h4>
               <ul>
                  <li>
                     <a
                        target="_blank"
                        href="https://vetcor.skyworld.com/userfilesV3/files/document-library/PMO/Sun%2C%20Fun%20and%20BW%20Done%20%20-%20Team%20Flyer.pdf">
                        Sun, Fun and BW Done - Team Flyer
                     </a>
                  </li>
                  <li>
                     <a
                        target="_blank"
                        href="https://vetcor.skyworld.com/userfilesV3/files/document-library/PMO/Sun%2C%20Fun%20and%20BW%20Done%20Progress%20Tracker.pdf">
                        Sun, Fun and BW Done - Progress Tracker
                     </a>
                  </li>
                  <li>
                     <a
                        target="_blank"
                        href="https://vetcor.skyworld.com/userfilesV3/files/Knowledge%20Ctr%20Items/Proactive%20Health%20Screening%20Guide%20Updated%20NEW.pdf">
                        Proactive Health Screens Best Practices
                     </a>
                  </li>
               </ul>
            </div>
         </div>

         <div
            *ngIf="!showBloodTests() && showLinks()"
            class="intro-box">
            <h2>Sun's Out, Links Out!</h2>
            <h6>Things are heating up. How many Vetcove Home Delivery links can you send?</h6>
            <p>
               Client engagement with your hospital's online ordering system reflect your team's success in offering convenient, accessible solutions
               that enhance the client experience and support ongoing pet health.
            </p>
            <a
               target="_blank"
               href="https://vetcor.skyworld.com/userfilesV3/files/document-library/PMO/Sun's%20Out%20-%20Links%20Out%20Contest%20Detailer.pdf">
               Sun's Out - Links Out Contest Detailer &raquo;
            </a>
            <div class="resources-box">
               <h4>Tools & Resources to Be Successful</h4>
               <ul>
                  <li>
                     <a
                        target="_blank"
                        href="https://vetcor.skyworld.com/userfilesV3/files/document-library/PMO/Suns%20Out%2C%20Links%20Out%20-%20Team%20Flyer.pdf">
                        Sun's Out - Links Out
                     </a>
                  </li>
                  <li>
                     <a
                        target="_blank"
                        href="https://vetcor.skyworld.com/userfilesV3/files/document-library/PMO/Suns%20Out%20Links%20Out%20Progress%20Tracker.pdf">
                        Sun's Out - Links Out Progress Tracker
                     </a>
                  </li>
                  <li>
                     <a
                        target="_blank"
                        href="https://vetcor.skyworld.com/userfilesV3/files/document-library/PMO/Vetcove%20Home%20Delivery%20Checkout%20Link%20Guide.pdf">
                        Vetcove Home Delivery Best Practices
                     </a>
                  </li>
                  <li>
                     <a
                        target="_blank"
                        href="https://vetcor.skyworld.com/knowledge-center?kid=681">
                        Vetcove Home Delivery Information
                     </a>
                  </li>
               </ul>
            </div>
         </div>

         <div
            #chartSection
            class="apps-inner-page-container">
            <div
               *ngIf="activeGoal()"
               class="progress-reactivated-goal-container">
               <div class="donut-chart therm">
                  <div class="thermometer-container">
                     <div class="thermometer-svg-container">
                        <svg
                           xmlns="http://www.w3.org/2000/svg"
                           class="thermometer-svg"
                           viewBox="103 22 114 260">
                           <defs>
                              <clipPath id="fill-clip">
                                 <rect
                                    x="103"
                                    [attr.y]="272 - fillPercent() * 246"
                                    width="114"
                                    [attr.height]="fillPercent() * 246"
                                    class="thermometer-clip-rect" />
                              </clipPath>
                           </defs>

                           <g clip-path="url(#fill-clip)">
                              <path
                                 d="M167 28.833A22.833 28.833 0 0 0 138.167 55.667v131.125a48.667 46.667 0 1 0 42.667 0V48.667A22.833 28.833 0 0 0 167 28.833"
                                 [attr.fill]="getFillColor('pets')"
                                 stroke="none" />
                           </g>

                           <path
                              d="M167 28.833A22.833 28.833 0 0 0 138.167 55.667v131.125a48.667 46.667 0 1 0 42.667 0V48.667A22.833 28.833 0 0 0 167 28.833"
                              fill="none"
                              stroke="#006fba"
                              stroke-width="10"
                              stroke-linecap="round"
                              stroke-linejoin="round" />
                        </svg>
                     </div>
                  </div>
               </div>

               <!-- Stats -->
               <div class="reactivated-goal-stats">
                  <h3>Pets Helped</h3>
                  <h1 class="count">{{ selectedPractice()?.stats?.totalPets }}</h1>
                  <p class="goal-label">
                     Goal:
                     <span>{{ selectedPractice()?.goal?.totalPets }}</span>
                  </p>

                  <div *ngIf="selectedPractice()?.goal && remainingPetsPerWeek() > 0">
                     <hr />
                     <h4>How to Achieve Your Goal</h4>
                     <div class="breakdown">
                        <div class="box">
                           <h2>{{ remainingPetsPerWeek() }}</h2>
                           <p>Pets per week</p>
                        </div>
                     </div>
                  </div>
                  <div *ngIf="selectedPractice()?.goal && remainingPets() !== null && remainingPets() <= 0">
                     <div class="breakdown">
                        <div class="box congrats">
                           <h6>Congrats!!</h6>
                           You have achieved your goal!
                        </div>
                        <div class="box">
                           <img
                              src="assets/leaderboard/catCongrats.gif"
                              class="catCongrats" />
                        </div>
                     </div>
                  </div>
               </div>

               <apx-chart
                  class="petsHelpedWeekly"
                  [series]="chartSeries"
                  [chart]="chartOptions().chart"
                  [xaxis]="chartOptions().xaxis"
                  [yaxis]="chartOptions().yaxis"
                  [stroke]="chartOptions().stroke"
                  [colors]="chartOptions().colors"
                  [markers]="chartOptions().markers"
                  [legend]="chartOptions().legend"
                  [dataLabels]="chartOptions().dataLabels"
                  [tooltip]="chartOptions().tooltip"></apx-chart>
            </div>
            <span
               *ngIf="!activeGoal()"
               class="notActiveGoal">
               <h2>This goal is not active for your hospital</h2>
            </span>
         </div>

         <div
            *ngIf="showBloodTests() && !showLinks()"
            class="apps-inner-page-container">
            <div
               *ngIf="activeBloodGoal()"
               class="progress-reactivated-goal-container">
               <div class="donut-chart therm">
                  <div class="thermometer-container">
                     <div class="thermometer-svg-container">
                        <svg
                           xmlns="http://www.w3.org/2000/svg"
                           class="thermometer-svg"
                           viewBox="103 22 114 260">
                           <defs>
                              <clipPath id="fill-clip-scans">
                                 <rect
                                    x="103"
                                    [attr.y]="272 - fillPercentScans() * 246"
                                    width="114"
                                    [attr.height]="fillPercentScans() * 246"
                                    class="thermometer-clip-rect" />
                              </clipPath>
                           </defs>

                           <g clip-path="url(#fill-clip-scans)">
                              <path
                                 d="M167 28.833A22.833 28.833 0 0 0 138.167 55.667v131.125a48.667 46.667 0 1 0 42.667 0V48.667A22.833 28.833 0 0 0 167 28.833"
                                 [attr.fill]="getFillColor('scans')"
                                 stroke="none" />
                           </g>

                           <path
                              d="M167 28.833A22.833 28.833 0 0 0 138.167 55.667v131.125a48.667 46.667 0 1 0 42.667 0V48.667A22.833 28.833 0 0 0 167 28.833"
                              fill="none"
                              stroke="#006fba"
                              stroke-width="10"
                              stroke-linecap="round"
                              stroke-linejoin="round" />
                        </svg>
                     </div>
                  </div>
               </div>

               <!-- Stats -->
               <div class="reactivated-goal-stats totalScans">
                  <h3>Proactive Health Screens</h3>
                  <h1 class="count">{{ totalBloodTestsAdjusted() ?? 0 }}</h1>
                  <p class="goal-label">
                     Goal:
                     <span>{{ scansGoal()?.totalBloodTests }}</span>
                  </p>

                  <div *ngIf="scansGoal() && remainingScansPerWeek() > 0">
                     <hr />
                     <h4>How to Achieve Your Goal</h4>
                     <div class="breakdown">
                        <div class="box">
                           <h2>{{ remainingScansPerWeek() }}</h2>
                           <p>Proactive health screens per week</p>
                        </div>
                     </div>
                  </div>

                  <div *ngIf="scansGoal()?.totalBloodTests > 0 && remainingScans() !== null && remainingScans() <= 0">
                     <div class="breakdown">
                        <div class="box congrats">
                           <h6>Congrats!!</h6>
                           You have achieved your goal!
                        </div>
                        <div class="box">
                           <img
                              src="assets/leaderboard/catCongrats.gif"
                              class="catCongrats" />
                        </div>
                     </div>
                  </div>
               </div>

               <apx-chart
                  class="petsHelpedWeekly"
                  [series]="chartSeriesScans"
                  [chart]="chartOptionsScans().chart"
                  [xaxis]="chartOptionsScans().xaxis"
                  [yaxis]="chartOptionsScans().yaxis"
                  [stroke]="chartOptionsScans().stroke"
                  [colors]="chartOptionsScans().colors"
                  [markers]="chartOptionsScans().markers"
                  [legend]="chartOptionsScans().legend"
                  [dataLabels]="chartOptionsScans().dataLabels"
                  [tooltip]="chartOptionsScans().tooltip"></apx-chart>
            </div>
            <span
               *ngIf="!activeBloodGoal()"
               class="notActiveGoal">
               <h2>This goal is not active for your hospital</h2>
            </span>
         </div>
         <div
            *ngIf="!showBloodTests() && showLinks()"
            class="apps-inner-page-container">
            <div
               #chartSection
               class="links-metrics-container">
               <div class="donut-chart">
                  <apx-chart
                     [series]="[selectedPractice()?.stats?.linksProgressPct * 100 || 0]"
                     [chart]="{ type: 'radialBar', height: 300 }"
                     [plotOptions]="{
                        radialBar: {
                           hollow: { size: '70%' },
                           dataLabels: {
                              name: {
                                 show: true,
                                 offsetY: -12,
                                 fontWeight: 500,
                                 fontFamily: 'Poppins',
                                 fontSize: '14px',
                                 style: {
                                    fontSize: '14px'
                                 }
                              },
                              value: {
                                 show: true,
                                 offsetY: 5,
                                 fontSize: '28px',
                                 fontWeight: 600,
                                 fontFamily: 'Poppins',
                                 color: '#f08c1c',
                                 style: {
                                    fontSize: '28px',
                                    fontWeight: 600,
                                    lineHeight: '43px'
                                 },
                                 formatter: formatDollarValue
                              },
                              total: {
                                 show: false
                              }
                           }
                        }
                     }"
                     [labels]="['Amount Earned']"
                     [colors]="['#f08c1c']"></apx-chart>
               </div>

               <div class="links-metrics-grid">
                  <div class="links-metric-box top-left">
                     <div class="metric-text">
                        <div class="metric-number">
                           {{ selectedPractice()?.stats?.currWeekBonusLinks ?? 0 }}
                           <sup>*</sup>
                        </div>
                        <div class="metric-label">Bonus Links</div>
                     </div>
                  </div>

                  <div class="links-metric-box top-right">
                     <div class="metric-text">
                        <div class="metric-number">
                           {{ selectedPractice()?.stats?.totalBonusLinks ?? 0 }}
                           <sup>*</sup>
                        </div>
                        <div class="metric-label">Total Bonus Links</div>
                     </div>
                  </div>

                  <div class="links-metric-box bottom-left">
                     <div class="metric-text">
                        <div class="metric-number">{{ selectedPractice()?.stats?.currWeekLinks ?? 0 }}</div>
                        <div class="metric-label">Links Sent This Week</div>
                     </div>
                  </div>

                  <div class="links-metric-box bottom-right">
                     <div class="metric-text">
                        <div class="metric-number">{{ selectedPractice()?.stats?.totalLinksSent ?? 0 }}</div>
                        <div class="metric-label">Total Links Sent Since Start</div>
                     </div>
                  </div>

                  <p class="link-bonus-note">
                     * Each week, you earn
                     <strong>$10</strong>
                     for each link sent after:
                     <strong>{{ selectedPractice()?.goal?.weeklyLinks }} links</strong>
                  </p>
               </div>
            </div>
         </div>

         <div class="apps-inner-page-container-centered">
            <vc-client-verification-card
               *ngIf="selectedPracticeData() && !isOmitted()"
               [percent]="selectedPracticeData().contactCompliancePct * 100 | number : '1.0-0'"
               [practiceSKey]="selectedPracticeSKey()"></vc-client-verification-card>
            <div
               *ngIf="isOmitted()"
               style="text-align: center">
               <h3 style="color: #0572ba">Client Contact Information %</h3>
               This hospital is omitted from the client validation requirement due to Impromed limitations.
            </div>
         </div>
      </ng-template>
   </section>

   <section class="thank-you">
      <h1>
         THANK YOU FOR DOING
         <span class="yourPart">Your Part</span>
      </h1>
      <div class="totals">
         <div class="total">
            <div
               class="number-display"
               style="text-align: right">
               <span>{{ totalVetcorSV() | number : "1.0-0" }}</span>
            </div>
            <label>Total Vetcor Pets Helped</label>
         </div>
         <div
            *ngIf="showBloodTests() || showLinks()"
            class="total">
            <div
               class="number-display"
               style="text-align: left">
               <span>{{ showBloodTests() ? totalBloodTests() : (totalVetcoveLinks() | number : "1.0-0") }}</span>
            </div>
            <label>{{ showBloodTests() ? "Total Vetcor Summer Scans" : "Total Vetcove Links Sent Out" }}</label>
         </div>
      </div>
   </section>

   <section class="leaderboards">
      <h1>HERE ARE OUR CURRENT LEADERS!</h1>
      <div class="leaderboard-tables">
         <leaderboard-rank-table
            title="Pets Helped Regional Leaders"
            isRegional="true"
            [practices]="regionalPractices()"
            [currentPracticeSKey]="selectedPracticeSKey()"
            [limit]="5"
            rankField="petsRegionalRank"></leaderboard-rank-table>

         <leaderboard-rank-table
            *ngIf="showBloodTests()"
            title="Vetcor Summer Scans Regional Leaders"
            isRegional="true"
            [filterNoRank]="true"
            [practices]="regionalScanStats()"
            [currentPracticeSKey]="selectedPracticeSKey()"
            [limit]="5"
            [showLinks]="false"
            rankField="bloodTestsRegionalRank"></leaderboard-rank-table>

         <leaderboard-rank-table
            *ngIf="!showBloodTests() && showLinks()"
            title="Vetcor Checkout Link Regional Leaders"
            isRegional="true"
            [practices]="regionalPractices()"
            [currentPracticeSKey]="selectedPracticeSKey()"
            [limit]="5"
            [showLinks]="true"
            rankField="linksRegionalRank"></leaderboard-rank-table>

         <leaderboard-rank-table
            title="Pets Helped Company Leaders"
            [practices]="practices()"
            [currentPracticeSKey]="selectedPracticeSKey()"
            rankField="petsVetcorRank"
            maxHeight="500px"></leaderboard-rank-table>

         <leaderboard-rank-table
            *ngIf="showBloodTests() && !showLinks()"
            title="Vetcor Summer Scans Company Leaders"
            [practices]="allScansStats()"
            [filterNoRank]="true"
            [currentPracticeSKey]="selectedPracticeSKey()"
            rankField="bloodTestsVetcorRank"
            [showLinks]="false"
            maxHeight="500px"></leaderboard-rank-table>

         <leaderboard-rank-table
            *ngIf="!showBloodTests() && showLinks()"
            title="Vetcor Checkout Link Company Leaders"
            [practices]="practices()"
            [currentPracticeSKey]="selectedPracticeSKey()"
            rankField="linksVetcorRank"
            [showLinks]="true"
            maxHeight="500px"></leaderboard-rank-table>
      </div>
   </section>

   <section class="help">
      <h6>
         Problem with your report?
         <a
            href="javascript:void(0);"
            (click)="zohoModal.openModal()"
            class="v-bluecolor">
            Click here to issue a helpdesk ticket
         </a>
      </h6>
   </section>
</div>

<app-zoho-ticket-modal
   #zohoModal
   subject="Leaderboard Report Issue"
   channel="SummerSplash"
   department="PMO"
   [practiceSKey]="selectedPracticeSKey()"></app-zoho-ticket-modal>
